import { render, staticRenderFns } from "./CustomSelectSlot.vue?vue&type=template&id=4fa11878&scoped=true&"
import script from "./CustomSelectSlot.vue?vue&type=script&lang=js&"
export * from "./CustomSelectSlot.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelectSlot.vue?vue&type=style&index=0&id=4fa11878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa11878",
  null
  
)

export default component.exports